<div class="bloco" [formGroup]="dados">
  <div class="sub-section-title">
  <mat-icon class="material-symbols-outlined">more_horiz</mat-icon>
  <span>Outras informações do item</span>
</div>

  <div class="row">
    <div class="col-12 col-md-4">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>GTIN / EAN</mat-label>
        <input matInput formControlName="gtinEan">
      </mat-form-field>
    </div>

    <div class="col-6 col-md-2">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Peso bruto (kg)</mat-label>
        <input matInput formControlName="pesoBruto" [currencyMask]="mascaraQuantidade"
          class="campo-numero">
      </mat-form-field>
    </div>

    <div class="col-6 col-md-2">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Peso líquido (kg)</mat-label>
        <input matInput formControlName="pesoLiquido" [currencyMask]="mascaraQuantidade"
          class="campo-numero">
      </mat-form-field>
    </div>

    <div class="col-12 col-md-4">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Tipo do item - SPED</mat-label>
        <mat-select formControlName="idTipoItemSped">
          <mat-option [value]="null">Não informado</mat-option>
          @for (t of lookups.tiposItemSped; track t.id) {
            <mat-option [value]="t.id">{{ t.descricao }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>

    <div class="col-12 col-md-4">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Nº do pedido do cliente</mat-label>
        <input matInput formControlName="numeroPedidoCliente">
      </mat-form-field>
    </div>

    <div class="col-6 col-md-2">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Item do pedido</mat-label>
        <input matInput formControlName="numeroItemPedido" [currencyMask]="mascaraInteira"
          class="campo-numero">
      </mat-form-field>
    </div>
  </div>
</div>
